import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {StyleSheet, TouchableOpacity, View, Text, Platform} from 'react-native';
import {CountryButton, CountryPicker} from 'react-native-country-codes-picker';
import {useSelector} from 'react-redux';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import {globalImport} from '../../../common/globalImports';
import ShowError from '../../../common/ShowError';
import {Button} from '../../../components/core/Button';
import {isMobile} from '../../../utils/commonMethods';
import {Network} from '../../../utils/network';
import {convert} from '../../../locale/translateText';
import {globalConfigurableData} from '../../../utils/globalConstant';
import {Input} from '../../../components/core/Input';
import moment from 'moment';
import CommonModal from '../../../commonComponents/commonModal';
import {BasicDetailImport} from '../../Profile/basicDetailsImport';
import {Controller} from 'react-hook-form';
import Select from '../../../components/core/Select';
import { useToast } from '../../../components/core/Toast';

const ProfileFill = ({
  setProfileFields,
  onAgeConfirmClick,
  ipSelectedCountry,
}) => {
  const { toast } = useToast();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: {errors, isValid, dirtyFields},
    control,
    setError: setErrorForm,
    clearErrors,
    setValue,
  } = useForm({mode: 'onChange'});

  const {
    register: registerPromo,
    control: controlPromo,
    watch: watchPromo,
    formState: {errors: errors2, isValid: isValid2},
    handleSubmit: handleSubmitPromo,
    reset: reset2,
  } = useForm({
    mode: 'onChange',
  });
  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  const detectedLocation = globalConfigData?.detected_location;
  const IsIndia = ipSelectedCountry?.iso_code === 'IN';
  const [show, setShow] = useState(false);
  const [IspromoSuccess, setIsPromoSuccess] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [country, setCountry] = useState(IsIndia ? ipSelectedCountry : null);
  let couponCode;
  couponCode = localStorage.getItem('couponCode');
  const [startDate, setStartDate] = useState(null);
  const [open, setOpen] = useState(false);

  const onSubmitPromoCode = (data, event) => {
    if (event) {
      event.preventDefault();
    }
    onPromoApply(data?.promoCode);
  };

  const promoEntered = watchPromo('promoCode');
  const isPromoValid = promoEntered && promoEntered.length > 2;

  useEffect(() => {
    if (detectedLocation || IsIndia || (couponCode && couponCode !== "undefined" && couponCode !== "null")) {
      const locationData = detectedLocation || (IsIndia ? ipSelectedCountry : null);
      if (locationData) {
        // Find matching country from globalConfigData.countries
        const matchedCountry = globalConfigData?.countries?.find(
          country => (country.iso_code === locationData.country_code || country.iso_code === locationData)
        );

        if (matchedCountry) {
          setCountry(matchedCountry);
          setValue('country', matchedCountry.country_name, {
            shouldValidate: true,
            shouldDirty: true,
          });
        } else {
          // Fallback if no match found
          setCountry({
            name: locationData.country_name || "India",
            iso_code: locationData.country_code || "IN",
            country_name: locationData.country_name || "INDIA"
          });
          setValue('country', locationData.country_name || 'INDIA', {
            shouldValidate: true,
            shouldDirty: true,
          });
        }
        setIsPromoSuccess(null);
      }
    }
  }, [couponCode, detectedLocation, globalConfigData?.countries]);

  useEffect(() => {
    if ((couponCode && couponCode !== "undefined" && couponCode !== "null") && country) {
      onPromoApply(couponCode);
      reset2({
        promoCode: couponCode,
      });
    }
  }, [country]);

  useEffect(() => {
    const tempList = [];
    globalConfigData?.countries?.map(data => {
      tempList.push(data?.iso_code);
    });
    setCountryList(tempList);
  }, [globalConfigData]);

  const onPromoApply = async promo => {
    if (country) {
      const inputObj = {
        coupon: promo,
        signup_country: country?.code || country?.iso_code,
      };
      const res = await Network.verifyCouponCode(inputObj);

      if (!res?.data?.isvalid) {
        setIsPromoSuccess({
          val: 'Apply',
          divClass: {borderColor: Colors.red, borderWidth: 2},
          message: res?.data?.message,
          errorClass: {color: Colors.red},
        });
      } else {
        setIsPromoSuccess({
          val: 'Remove',
          divClass: {borderColor: Colors.green, borderWidth: 2},
          message: res?.data?.message,
          errorClass: {color: Colors.green},
        });
      }
    } else {
      toast({
        title: convert('Please select a Country'),
        variant: 'destructive',
      });
    }
  };

  const handleDateChange = (date) => {
    const formattedDate = moment(date).format('DD-MM-YYYY');
    setValue('dateOfBirth', formattedDate);
    setStartDate(formattedDate);
    setOpen(false);
  };

  const onFormSubmit = data => {
    let profileObj = {
      displayname: data?.profileName,
      dob: startDate,
    };

    if (IspromoSuccess?.val === 'Remove') {
      profileObj = {...profileObj, referral_code: promoEntered};
    }

    setProfileFields(profileObj);
  };

  useEffect(() => {
    if (promoEntered && IspromoSuccess?.divClass?.borderColor === Colors.red) {
      setIsPromoSuccess(null);
    }
  }, [promoEntered]);

  const onPromoButtonClick = () => {
    if (IspromoSuccess?.val === 'Remove') {
      setIsPromoSuccess(null);
      reset2({
        promoCode: '',
      });
      localStorage.removeItem('couponCode');
    } else if (isPromoValid) {
      handleSubmitPromo(onSubmitPromoCode)();
    }
  };

  return (
    <View style={{marginTop: 50}}>
      <View style={styles.headerContainer}>
        <Text style={styles.headerTitle}>Your Basic Details</Text>
        <Text style={styles.headerSubtext}>
          To get started, please fill out this section in order to customise your
          experience
        </Text>
      </View>
      <View style={styles.inputContainer}>
        <Text style={styles.labelStyles}>Your Name</Text>
        <View style={{
          backgroundColor: globalConfigurableData.cardBgColor,
          borderRadius: 8,
          borderWidth: 1,
          overflow: 'hidden',
          borderColor: errors?.profileName ? Colors.red : globalConfigurableData.borderColor,
        }}>
          <Input
            name="profileName"
            placeholder="Enter Full Name"
            control={control}
            variant="outline"
            containerStyle={{
              marginBottom: 0,
              backgroundColor: 'transparent',
            }}
            style={{
              borderWidth: 0,
            }}
            inputStyle={{
              borderWidth: 0,
              backgroundColor: 'transparent',
              height: 46,
            }}
            fullWidth
            rules={{
              required: "Please enter your Name",
              pattern: {
                value: /^[A-Za-z\s]+$/,
                message: "Name should only contain alphabets and spaces"
              }
            }}
            hideError={true}
          />
        </View>
        {errors?.profileName && (
          <Text style={styles.errorText}>{errors.profileName.message}</Text>
        )}
      </View>

      <View style={styles.inputContainer}>
        {/* <Text style={styles.labelStyles}>Your Country</Text> */}
        {/* <TouchableOpacity
          activeOpacity={0.9}
          onPress={() => {
            if (!detectedLocation && !IsIndia) {
              setShow(true);
            }
          }}>
          <View style={{
            backgroundColor: globalConfigurableData.cardBgColor,
            borderRadius: 8,
            borderWidth: 1,
            overflow: 'hidden',
            borderColor: errors?.country ? Colors.red : globalConfigurableData.borderColor,
            opacity: detectedLocation || IsIndia ? 0.7 : 1,
          }}>
            <Input
              name="country"
              placeholder="Enter Country"
              control={control}
              variant="outline"
              containerStyle={{
                marginBottom: 0,
                backgroundColor: 'transparent',
              }}
              style={{
                borderWidth: 0,
                cursor: 'pointer',
              }}
              inputStyle={{
                borderWidth: 0,
                backgroundColor: 'transparent',
                height: 46,
                paddingRight: 50,
              }}
              fullWidth
              disabled={true}
              rules={{
                required: true,
              }}
            />
          </View>
        </TouchableOpacity> */}
        {errors?.country?.type === 'required' && (
          <Text style={styles.errorText}>Please select country</Text>
        )}

        {countryList.length > 0 && (
          <CountryPicker
            style={{
              modal: styles.modalPicker,
              flag: {borderRadius: 50},
              textInput: {
                paddingHorizontal: 20,
                height: 50,
              },
              countryButtonStyles: {
                borderRadius: 8,
                marginTop: 5,
                flex: 1,
              },
              backdrop: {
                backgroundColor: Colors.bgWhite,
                opacity: 0,
              },
            }}
            show={show}
            pickerButtonOnPress={item => {
              setCountry(item);
              setIsPromoSuccess(null);
              setShow(false);
              setValue('country', item?.name?.en, {
                shouldValidate: true,
                shouldDirty: true,
              });
            }}
            showOnly={countryList}
            onBackdropPress={() => setShow(false)}
            lang={'en'}
            inputPlaceholder={'Type your country or code'}
            searchMessage={'Some search message here'}
          />
        )}
      </View>

      <View style={styles.inputContainer}>
        <Text style={styles.labelStyles}>Promo Code (if any)</Text>
        <View style={{
          flexDirection: 'row',
          alignItems: 'center',
          backgroundColor: globalConfigurableData.cardBgColor,
          borderRadius: 8,
          borderWidth: 1,
          overflow: 'hidden',
          borderColor: IspromoSuccess?.divClass?.borderColor || globalConfigurableData.borderColor,
        }}>
          <View style={{flex: 1}}>
            <Input
              name="promoCode"
              placeholder="ex: TRADEX50"
              control={controlPromo}
              variant="outline"
              containerStyle={{
                marginBottom: 0,
                backgroundColor: 'transparent',
              }}
              style={{
                borderWidth: 0,
              }}
              inputStyle={{
                borderWidth: 0,
                backgroundColor: 'transparent',
                height: 46,
              }}
              fullWidth
            />
          </View>
          <View style={{
            width: 1,
            alignSelf: 'stretch',
            backgroundColor: IspromoSuccess?.divClass?.borderColor || globalConfigurableData.borderColor,
          }} />
          <TouchableOpacity
            style={{
              height: 46,
              paddingHorizontal: 20,
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'transparent',
            }}
            onPress={IspromoSuccess?.val === 'Remove' || isPromoValid ? onPromoButtonClick : () => {}}>
            <Text style={{
              ...globalFontStyle.appFontSmallTextBold,
              color: IspromoSuccess?.divClass?.borderColor === Colors.green 
                ? Colors.green 
                : IspromoSuccess?.divClass?.borderColor === Colors.red
                  ? Colors.red
                  : isPromoValid
                    ? globalConfigurableData.primaryTextColor1
                    : globalConfigurableData.secondaryTextColor1,
            }}>
              {IspromoSuccess ? IspromoSuccess?.val : 'Apply'}
            </Text>
          </TouchableOpacity>
        </View>
        {IspromoSuccess?.message && <ShowError error={IspromoSuccess} />}
      </View>

      <View style={styles.inputContainer}>
        <Text style={styles.labelStyles}>Date of Birth (DD-MM-YYYY)</Text>
        {Platform.OS === 'web' ? (
          <Controller
            control={control}
            name="dateOfBirth"
            rules={{ required: 'Please enter your DOB' }}
            render={({ field: { onChange, value } }) => {
              const [isOpen, setIsOpen] = useState(false);
              
              return (
                <div style={{ position: 'relative' }}>
                  <Input
                    name="dateOfBirth"
                    control={control}
                    variant="default"
                    size="default"
                    value={startDate || ''}
                    disabled={true}
                    placeholder="DD-MM-YYYY"
                    rules={{
                      required: 'Please enter your DOB'
                    }}
                    isDateInput={true}
                    onClick={() => setIsOpen(true)}
                  />
                  <div style={{ position: 'absolute', zIndex: 999 }}>
                    <BasicDetailImport.DatePicker
                      selected={startDate ? moment(startDate, 'DD-MM-YYYY').toDate() : null}
                      onChange={(date) => {
                        handleDateChange(date);
                        onChange(moment(date).format('DD-MM-YYYY'));
                        setIsOpen(false);
                      }}
                      maxDate={new Date(moment().subtract(18, 'years'))}
                      minDate={new Date(1950, 0, 1)}
                      dateFormat="dd-MM-yyyy"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      open={isOpen}
                      onClickOutside={() => setIsOpen(false)}
                      customInput={<div style={{ display: 'none' }} />}
                    />
                  </div>
                </div>
              );
            }}
          />
        ) :
          <>
            <TouchableOpacity
              onPress={() => setOpen(true)}>
              <Input
                name="dateOfBirth"
                control={control}
                label="Date of Birth (DD-MM-YYYY)"
                variant="default"
                size="default"
                value={startDate || ''}
                disabled={true}
                placeholder="DD-MM-YYYY"
                rules={{
                  required: 'Please enter your DOB'
                }}
                isDateInput={true}
              />
            </TouchableOpacity>

            <CommonModal
              onModalCallBack={() => setOpen(false)}
              showModal={open}
              customModalStyle={styles.datePickerModal}>
              <View style={styles.datePickerContainer}>
                <BasicDetailImport.DatePicker
                  value={startDate ? moment(startDate, 'DD-MM-YYYY').toDate() : new Date(moment().subtract(18, 'years'))}
                  onChange={handleDateChange}
                  maximumDate={new Date(moment().subtract(18, 'years'))}
                  minimumDate={new Date(1950, 0, 1)}
                  mode="date"
                  display="spinner"
                />
                <TouchableOpacity
                  style={styles.doneBtnContainer}
                  onPress={() => setOpen(false)}>
                  <Text style={styles.doneBtn}>Done</Text>
                </TouchableOpacity>
              </View>
            </CommonModal>
          </>
        }
      </View>

      <View style={{paddingVertical: 30}}>
        <Button
          variant="primary"
          onPress={handleSubmit(onFormSubmit)}
          style={{flex: globalImport.isWeb ? {} : 0, marginTop: 15}}
          disabled={!isValid || Object.keys(errors).length > 0}
        >
          Proceed
        </Button>
      </View>
    </View>
  );
};

export default ProfileFill;

const styles = StyleSheet.create({
  inputContainer: {
    marginBottom: 16,
  },
  inputDiv: {
    flexDirection: 'row',
    marginBottom: 0,
    paddingLeft: 0,
    borderRadius: 6,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: globalConfigurableData.borderColor,
  },
  errorText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.red,
    marginTop: 4,
    marginLeft: 2,
  },
  labelStyles: {
    color: globalConfigurableData.secondaryTextColor1,
    ...globalFontStyle.appFontBody,
    fontSize: 13,
    fontWeight: '400',
    marginLeft: 2,
    marginBottom: 4,
    opacity: 0.8,
    textAlign: 'left',
  },
  inputLogin: {
    borderRadius: 6,
    height: 46,
    borderWidth: 0,
    padding: 5,
    paddingHorizontal: 8,
    ...globalFontStyle.appFontBody,
  },
  promoInternalBtn: {
    height: 32,
    paddingHorizontal: 16,
    borderRadius: 6,
    backgroundColor: Colors.bgWhite,
    borderColor: globalConfigurableData.borderColor,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    top: 7,
    transition: 'all 0.3s ease',
  },
  promoButtonText: {
    ...globalFontStyle.appFontBody,
    fontSize: 13,
    fontWeight: '500',
  },
  modalPicker: {
    shadowColor: 'rgba(34, 48, 73, 0.2)',
    shadowOpacity: 66,
    position: 'absolute',
    top: 230,
    shadowRadius: 66,
    shadowOffset: {width: 20, height: 20},
    height: isMobile() ? 500 : 400,
    width: 300,
    borderRadius: 8,
    left: isMobile() ? 15 : Width.width / 2 + 15,
    backgroundColor: Colors.bgWhite,
  },
  headerContainer: {
    marginBottom: 32,
  },
  headerTitle: {
    ...globalFontStyle.appFontEventTitle,
    fontSize: 24,
    fontWeight: '600',
    color: globalConfigurableData.primaryTextColor1,
    marginBottom: 8,
  },
  headerSubtext: {
    ...globalFontStyle.appFontSubText,
    fontSize: 14,
    lineHeight: 20,
    color: globalConfigurableData.secondaryTextColor1,
    opacity: 0.8,
  },
  datePickerContainer: {
    backgroundColor: Colors.bgWhite,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    borderTopWidth: 1,
    borderTopColor: Colors.grey3,
  },
  doneBtnContainer: {
    alignItems: 'flex-end',
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: Colors.grey3,
  },
  doneBtn: {
    color: Colors.blue,
    fontSize: 16,
    fontWeight: '600',
  },
  datePickerModal: {
    alignItems: 'stretch',
  },
});
